import React, { useState } from 'react'
import TabContent from './TabContent'
import FAQSection from '../FAQSection/FAQSection'
import AdvisorsBlock from '../Advisors/AdvisorsBlock'
import { trackEvent } from '../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../context/MatchScreenContext'
import { useAdvisorsData } from '../../hooks/useAdvisorsData'
import '../../styles/TabSection/TabSection.scss'

const TabSection = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const { state } = useMatchScreen()
  const pageKey = state?.pageKey

  const advisorsData = useAdvisorsData()

  if (!advisorsData) {
    return (
      <div className="advisors_container">
        <div>Loading advisor data...</div>
      </div>
    )
  }

  const onTitleClick = (index: number, tabTitle: string) => {
    trackEvent('MatchScreen', 'handoff-faq-click', {
      page_key: pageKey,
      Position: tabTitle
    })
    setActiveIndex(index)
  }

  const tabs = [
        <AdvisorsBlock key={'tab_0'} advisorData={advisorsData} />,
        <FAQSection key={'tab_1'} />
  ]

  const tabTitles: string[] = [
    'Compare Your Matches',
    'FAQs'
  ]

  return (
        <div className="advisors_container">
            <ul className="tabs">
                {tabTitles.map((tabTitle, index) => (
                    <li
                        onClick={() => { onTitleClick(index, tabTitle) }}
                        className={`${activeIndex === index ? 'active' : ''}`}
                        key={index}
                    >
                        <span>{tabTitle}</span>
                    </li>
                ))}
            </ul>
            {tabs.map((tab, index) => (
                <TabContent key={index} active={activeIndex === index}>
                    {tab}
                </TabContent>
            ))}
        </div>
  )
}

export default TabSection
